const e="simple",t="animated";export{t as SPRITETYPE_ANIMATED,e as SPRITETYPE_SIMPLE};
